export { default } from "../../atoms/Input";



// WEBPACK FOOTER //
// ./src/design-system/molecules/LoadingInput/index.jsx